import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import formatNumber from './formatNumber';
import dateFormat from './dateFormat';
export default {};
Vue.use(VueI18n);
Vue.use(formatNumber);
Vue.use(dateFormat);
const i18n = new VueI18n({
	locale: 'locale',
	fallbackLocale: 'locale',
	messages: {
		locale: window.langMap,
	},
});

window.addEventListener('DOMContentLoaded', function () {

	// send event to initialize non-Vue functionality
	document.dispatchEvent(new CustomEvent('lichen:loaded'));
	
	// initialize components on page load
	if (document.querySelector('[data-lichen-vue]')) {
		var els = document.querySelectorAll('[data-lichen-vue]');
		Array.prototype.forEach.call(els, function (el) {
			new Vue({ el: el, i18n });
		});
	}

	// Header interactivity
	if (document.getElementById('header')) {
		var headerElement = document.getElementById('header');
		var headerClosers = document.querySelectorAll('[data-header-closer]');
		Array.prototype.forEach.call(headerClosers, function (el) {
			el.addEventListener('click', function (e) {
				e.stopPropagation();
				headerElement.focus();
				//console.log('Shifted focus back to header.');
			});
		});
	}

	// initialize modals
	if (document.querySelector('[data-lichen-dialog]')) {
		const els = document.querySelectorAll('[data-lichen-dialog]');
		Array.prototype.forEach.call(els, function (el) {
			const id = el.getAttribute('data-lichen-dialog');
			new Vue({
				el: el,
				i18n,
				data() {
					return {
						open: false,
						opener: null,
						id: id,
					};
				},
				mounted() {
					const togglers = document.querySelectorAll('[aria-controls="' + this.id + '"]');
					Array.prototype.forEach.call(togglers, (toggler) => {
						toggler.addEventListener('click', this.show);
					});
					// only for exotics dialog from inside CloLightbox
					document.addEventListener('lichen:exotics-dialog', (e) => {
						this.opener = e.detail.opener
						this.open = true
					});
				},
				methods: {
					show(e) {
						this.open = true;
						this.opener = e.target;
					},
					close() {
						this.open = false;
						// important: put focus back on element that triggered the dialog
						if (this.opener) {
							this.opener.focus();
						}
					},
				},
			});
		});
	}

	// lazy load components with data-lichen-vue-lazy attribute
	var lichenComponentObserver = new IntersectionObserver(function (changes) {
		changes.forEach(function (change) {
			var el = change.target;
			// check the lazy attribute and if it's intersecting the viewport
			if (el.hasAttribute('data-lichen-vue-lazy') && change.intersectionRatio > 0) {
				// wait for the browser to idle
				requestAnimationFrame(function () {
					el.removeAttribute('data-lichen-vue-lazy');
					el.setAttribute('data-lichen-vue', true);
					if (el.hasAttribute('data-lichen-url')) {
						var url = el.getAttribute('data-lichen-url');
						axios.get(url).then(function (res) {
							
							new Vue({
								el: el,
								data() {
									return { response: res.data };
								},
								mounted() {
									//console.log('mounted', this.response);
								},
								i18n,
							});
						});
					} else {
						new Vue({ el: el, i18n });
					}
				});
			}
		});
	});
	Array.prototype.map.call(document.querySelectorAll('[data-lichen-vue-lazy]'), function (el) {
		lichenComponentObserver.observe(el);
	});
});